import React from "react";
import { AppKYCStatusPage } from "@features/AppKYC/AppKYCStatusPage";
import { AppKYCTokenWrapper } from "@features/AppKYC/AppKYCTokenWrapper";
import { CheckmarkIcon, ClockIcon, CrossIcon } from "@components/icons";
import { Modals } from "@components/Modal/Modals";
import { sentryCreateBrowserRouter } from "@/sentry";

export const appKYCModeRouter = () => {
  return sentryCreateBrowserRouter([
    {
      path: "*",
      element: (
        <React.Suspense fallback={<></>}>
          <Modals />
          <AppKYCTokenWrapper />
        </React.Suspense>
      ),
    },
    {
      path: "/status/error",
      element: (
        <React.Suspense fallback={<></>}>
          <AppKYCStatusPage
            badgeProps={{
              color: "red",
              icon: CrossIcon,
            }}
            title="KYC.modal.authentication.error.title"
            description="KYC.modal.authentication.error.description"
          />
        </React.Suspense>
      ),
    },
    {
      path: "/status/pause",
      element: (
        <React.Suspense fallback={<></>}>
          <AppKYCStatusPage
            badgeProps={{
              color: "yellow",
              icon: ClockIcon,
            }}
            title="KYC.modal.authentication.pause.title"
            description="KYC.modal.authentication.pause.description"
          />
        </React.Suspense>
      ),
    },
    {
      path: "/status/success",
      element: (
        <React.Suspense fallback={<></>}>
          <AppKYCStatusPage
            badgeProps={{
              color: "green",
              icon: CheckmarkIcon,
            }}
            title="KYC.modal.authentication.success.title"
            description="KYC.modal.authentication.success.description"
          />
        </React.Suspense>
      ),
    },
  ]);
};
